export const forgotPasswordTheme = {
  associatedEmail: 'palette.primary.60',
  subtitle: 'palette.neutral.80',
  title: 'palette.tertiary.95',
};
